import { useProject } from ':cloud/contexts/ProjectContext';
import { useGetApiKeys } from ':cloud/queries/ApiKeyQueries/useGetApiKeys';
import { IPlatformAPIKey } from ':cloud/types/ts_types';

export function useSelectedProjectAPIKeys(): {
  projectKeys: IPlatformAPIKey[];
  isKeysLoading: boolean;
} {
  const { selectedProject } = useProject();
  const { keys, isLoading } = useGetApiKeys(selectedProject?.id);

  return {
    projectKeys: keys || [],
    isKeysLoading: isLoading,
  };
}
